import {Injectable} from '@angular/core';
import {Product} from '../classes/product';
import {Cartitems2} from '../classes/cartitems';
import {Cartitems} from '../classes/cartitems';
import {BehaviorSubject, Observable, Subject, Subscriber } from 'rxjs';
import { map  } from 'rxjs/operators';
import { Http, Response ,Headers } from '@angular/http'
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class CartService {
public datac: Cartitems[];
public data: Cartitems[];
cartitems: Cartitems2[];
public items: number;
sidenav: number = 0;
private managecart = new BehaviorSubject<number>(this.items);
totalcartitems = this.managecart.asObservable();
private cdtk= "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjZlOWVlZDVjODQ5Yzk1YTVlNjIwYTUyMDMwMTYyMDJiOTBmYzAxNzRkMzA3NDc0OTc1ZmFlMDgyNDdkMGNhNjdiNmFhMzIzM2NmMjgyYjA0In0.eyJhdWQiOiIzIiwianRpIjoiNmU5ZWVkNWM4NDljOTVhNWU2MjBhNTIwMzAxNjIwMmI5MGZjMDE3NGQzMDc0NzQ5NzVmYWUwODI0N2QwY2E2N2I2YWEzMjMzY2YyODJiMDQiLCJpYXQiOjE1MzE0MDA3MjcsIm5iZiI6MTUzMTQwMDcyNywiZXhwIjoxNTYyOTM2NzI3LCJzdWIiOiIiLCJzY29wZXMiOltdfQ.dz0LSq7-jtxzrLmH6KgrNFGBYYq7UHf9n10owKt1JSoUdoLiCJJEmTprHufPiBrzu_6FxwivAUW5gD6yCQicAeVvxqBk1V3lNJduKt8TrCqeJWhqlECRvPp-fRJsbh3ZxsPwysKrAlb2AeWBv_NowO7nRyB4IpUiTatmV_Ud41WdM_pW-hBdJGLlX8-m5wHRYGOyMQay257byTtqOtJHVpouZd8b3Itta2uVX4cVaGgtTosebKfuLYG_xs5yLGMXXuab8pL2e5IdhYsYe1WJ0n-1qUK0ZH26WyLBZzEQ7s7DR3HGJN_YfBRLEDRmphvnYxBeAfiKtl1G4ztFSOksG5Qwxq-YugCODot_AmiNvUVxqRumgzegyx-xJN-Xc7ATbghFQ9iJwpLRiiqbQrFtsAe8eB6dLMpQ-mV4wFqZp51EQtAViW0LL9Rb9z1pghaMhBdurNyKCr5r-dMgI8fPAUd5iEQ8lloz-BJ_dowSiotHiPMNgpQOuQ_3lMKZyWs9UGxyCzCJ5g52Pe28Qvd8KLZ5uyI6pOQZNBRHGD0QRjn9erW3tDGDWx-Teba77YiLlpGjpX9zxbruEun0n3BlorGX7QEncW9riLorDC8OnWPNvgL1Iu1d1sEYYFKdfJETfrBCcrDWjexHWtbBtZZEthztq1wPiqbtOw5INiTjV6Q";
clientcredentialheader = new Headers({'Content-Type':'application/json',
'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest',
'Authorization': this.getClientCredential()});
 authcredheader: any;
  constructor(private http: Http,@Inject(PLATFORM_ID) private platformId: Object) {}
  getClientCredential(){
    var Bearer= 'Bearer' + ' ' + this.cdtk;
    return Bearer;
  }
getAuthCredential(){
  if (isPlatformBrowser(this.platformId)) {
    var a = localStorage.getItem("token");
    var tjson =JSON.parse(a);
    if(tjson != null){
      var auth= 'Bearer' + ' ' +  tjson.token;
      return auth;
    }
  }
  }
  genAuthHeader(){
    
    this.authcredheader = new Headers({'Content-Type':'application/json',
    'Accept':'application/json', 
    'Authorization': this.getAuthCredential()})
  }

  public addToCart(datac ) {
    return this.http.post('https://passport.petcart.in/cartitems', datac,
  {headers: this.clientcredentialheader})
    .pipe(map(res => res.json())
  ) ;

  }

 //totalcartitems: BehaviorSubject<number> = new BehaviorSubject<number>(this.items);
 sidenavopen: BehaviorSubject<number> = new BehaviorSubject<number>(this.sidenav);

 changeTotalCartItems(item) {
  this.managecart.next(item);
 }

 getUserData(email) {
   this.genAuthHeader();
  return this.http.get('https://passport.petcart.in/users?email=' + email,
{headers: this.authcredheader})
 .pipe(map(
     (response: Response) => {
     return response.json().data;
 })
 );
}
getUserDataByMobile(mobile){
  this.genAuthHeader();
  return this.http.get('https://passport.petcart.in/users?mobile=' + mobile,
{headers: this.authcredheader})
 .pipe(map(
     (response: Response) => {
     return response.json().data;
 })
 );
}
getUserLastorder(uid) {
  this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/orders?sort_bydesc=created_at&user_id=' + uid,
    {headers: this.authcredheader})
      .pipe(map(
        (response: Response) => {
          return response.json().data.slice(0, 10);
        }) 
      );
}
updateCartDetail(id: number, mrp: number, discount: number, quantity: number, discprice: number,
  tax: number, payable: number , user_id: number, user_name: string, product_name: string, sku: string) {
     return this.http.put('https://passport.petcart.in/cartitems/' + id,
     {mrp: mrp, discount: discount, discprice: discprice, quantity: quantity,
      payable: payable, tax: tax, user_id: user_id, user_name: user_name, product_name: product_name, sku: sku},
      {headers: this.clientcredentialheader})
     .pipe(map(
     (response: Response) => response.json().data
      )
    );
    }

deleteCart(id: number) {
    return this.http.delete('https://passport.petcart.in/cartitems/' + id,
    {headers: this.clientcredentialheader})
    .pipe(map(
     (response: Response) => response.json().data
    ));
  }

getUserCartItems(id: number): Observable<any>{
  
    return this.http.get('https://passport.petcart.in/cartitems?user_id=' + id,
   {headers: this.clientcredentialheader})
  .pipe(map(
     (response: Response) => {
       return response.json().data;
     })
     );
   }

   getGuestCartItems(guestname: string): Observable<any>{
    
    return this.http.get('https://passport.petcart.in/cartitems?user_name=' + guestname ,
    {headers: this.clientcredentialheader})
  .pipe(map(
     (response: Response) => {
       return response.json().data;
     })
     );
    }

   getUserAddress(id: number): Observable<any> {
     this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/shippingadd?user_id=' + id,
    {headers: this.authcredheader})
  .pipe(map(
     (response: Response) => {
      return response.json().data;
     })
     );
   }
   getShippingAddress(edid) {
     this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/shippingadd?id=' + edid,
    {headers: this.authcredheader})
   .pipe(map(
      (response: Response) => {
       return response.json().data;
      })
      );
   }
   getBillingAddress(edid) {
     this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/billingadd?id=' + edid,
    {headers: this.authcredheader})
   .pipe(map(
      (response: Response) => {
       return response.json().data;
      })
      );
   }
   getUserdefaultAddress(id) {
     this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/shippingadd?user_id=' + id + '&isdefault=' + 1,
    {headers: this.authcredheader})
   .pipe(map(
      (response: Response) => {
       return response.json().data;
      })
    ); 
   }
   getUserBillingAddress(id: number): Observable<any>{
     this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/billingadd?user_id=' +id,
    {headers: this.authcredheader})
  .pipe(map(
     (response: Response) => {
      return response.json().data;
     })
     );
   }

  createUserBillingAddress(user_id: number,name: string, addline1: string, addline2: string, cityid: number,
     stateid: number, countryid: number, pin: string, phone: string, lat , lon) {

  this.genAuthHeader();
   return this.http.post('https://passport.petcart.in/billingadd',
     {user_id: user_id,name:name,add_l1:addline1,add_l2:addline2,city_id: cityid,state_id:stateid,
      country_id:countryid,pin:pin,phone:phone,lat:lat,lon:lon},
      {headers: this.authcredheader}
     )
   .pipe(map(
     (response: Response) => response.json().data
    ));
  }


  createUserShippingAddress(user_id: number,name: string, addline1: string, addline2: string, 
    cityid: number, stateid: number, countryid: number, pin: string, phone:string,isdefault:number,
  lat, lon) {
  this.genAuthHeader();
   return this.http.post('https://passport.petcart.in/shippingadd',
     {user_id: user_id, name: name, add_l1: addline1, add_l2: addline2, city_id: cityid, state_id: stateid,
      country_id: countryid, pin: pin, phone: phone, isdefault: isdefault, lat: lat, lon: lon},
      {headers: this.authcredheader}
     )
   .pipe(map(
     (response: Response) => response.json().data
    ));
  }
  changeShipDefault(id: number, user_id: number, name: string, addline1: string, addline2: string,
    cityid: number, stateid: number, countryid: number, pin: string, phone: string, isdefault: number,
  lat: any, lon: any) {
    this.genAuthHeader();
     return this.http.put('https://passport.petcart.in/shippingadd/' + id,
     {user_id: user_id, name: name, add_l1: addline1, add_l2: addline2, city_id: cityid, state_id: stateid,
      country_id: countryid, pin: pin, phone: phone, isdefault: isdefault, lat: lat, lon: lon},
      {headers: this.authcredheader})
      .pipe(map(
     (response: Response) => response.json().data
    ));

   }

   deleteShipAddress(id: number) {
     this.genAuthHeader();
    return this.http.delete('https://passport.petcart.in/shippingadd/' + id,
    {headers: this.authcredheader})
    .pipe(map(
     (response: Response) => response.json().data
    ));

   }
   createCart(id: number, name: string, sku: string, price: number, discount: number, tdiscount: number, quantity:number,payable: number,
    tax: number, user_id: number, user_name: string) {
    return this.http.post('https://passport.petcart.in/cartitems',
     {product_id: id, product_name: name, sku: sku, mrp: price, discount: discount, discprice: tdiscount,
      quantity: quantity, payable: payable, tax: tax, user_id: user_id, user_name: user_name},
      {headers: this.clientcredentialheader}
     )
   .pipe(map(
     (response: Response) => response.json().data
    ));
  }

  updateCartIfPresent(id: number,quantity: number, payable: number) {
     return this.http.put('https://passport.petcart.in/cartitems/' + id,
     { quantity: quantity, payable: payable},
     {headers: this.clientcredentialheader})
      .pipe(map(
     (response: Response) => response.json().data
    ));
    }
  generateOrderItems(order_id: string, product_id: number, product_name: string, sku: string,
    price: number, discount: number, tdiscount: number, quantity: number, payable: number, tax: number) { 
      this.genAuthHeader();
    return this.http.post('https://passport.petcart.in/orderitems',
     { order_id: order_id, product_id: product_id, product_name: product_name, sku: sku, mrp: price,
      discount: discount, discprice: tdiscount, quantity: quantity, payable: payable, tax: tax},
     {headers: this.authcredheader}
     )
   .pipe(map(
     (response: Response) => response.json().data
   )); 

  }

   placeOrder(orderno: string,date:string,user_id:number,user_name: string,totalmrp:number,
    totaltax:number,discount: number,payable: number,shipping_mode: any, payment_mode: any, payment_stats: any,
    user_mobile: string,user_email:string,status_id:number,billingadd_id:number,shippingadd_id:number, ip, sr) { 
      this.genAuthHeader();
    return this.http.post('https://passport.petcart.in/orders',
     {orderno: orderno,date:date,user_id: user_id,user_name:user_name,totalmrp:totalmrp,
      totaltax: totaltax,discount:discount,payable: payable,shipping_mode: shipping_mode,
      payment_mode: payment_mode, payment_status: payment_stats, user_mobile: user_mobile,user_email: user_email,
      status_id:status_id,billingadd_id: billingadd_id,shippingadd_id:shippingadd_id , ip: ip, source: sr},
     {headers: this.authcredheader}
     )
   .pipe(map(
     (response: Response) => response.json().data
    ));

  }

  changeOrderstatus(id, payment_status) {
    this.genAuthHeader();
    return this.http.put('https://passport.petcart.in/orders/' + id,
    {payment_status: payment_status},
    {headers: this.authcredheader})
   .pipe(map(
     (response: Response) => {
       return response.json().data;
     })
   );
  }

   placeOrderType(orderid: string, city_id: number, store_id: number, order_type: number) {
     return this.http.post('https://passport.petcart.in/ordertypes',
       {orderno: orderid, city_id: city_id, store_id: store_id, order_type: order_type})
       .pipe(map(
     (response: Response) => response.json().data
    ));
  }

  updateUseridInCart(id, uid) {
    return this.http.put('https://passport.petcart.in/cartitems/' + id,
    {user_id : uid},
    {headers: this.clientcredentialheader})
    .pipe(map(
    (response: Response) => response.json().data
   ));
  }
  updateUserQuantityIncart(id,qty, pbl) {
    return this.http.put('https://passport.petcart.in/cartitems/' + id,
    {quantity : qty, payable: pbl},
    {headers: this.clientcredentialheader})
    .pipe(map(
    (response: Response) => response.json().data
   ));
  }

  getMyOrder(uid) {
    this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/orders?sort_bydesc=created_at&user_id=' + uid,
    {headers: this.authcredheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      }
    ));
  }
  getOrderDetail(orderid) {
    this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/orderitems?order_id=' + orderid,
    {headers: this.authcredheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      }
    ));
  }
  updateOrderStatus(id) {
    const status = 7;
    this.genAuthHeader();
    return this.http.put('https://passport.petcart.in/orders/' + id,
  {status_id: status}, {headers: this.authcredheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      }
    ));
  }
  getOrderStatus() {
    this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/orderstatus',
    {headers: this.authcredheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      }
    ));
  }
  getInventoryForCancellation(pid, cityid) {
    return this.http.get('https://passport.petcart.in/invcheck?product_id=' + pid + '&city_id=' + cityid,
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      }
    ));
  }
  updateInvForCancellation(updateid, astock, tstock) {
    this.genAuthHeader();
    return this.http.put('https://passport.petcart.in/invcheck/' + updateid,
    {actualstock: astock, totalstock: tstock},
    {headers: this.authcredheader} )
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      }
    ));
  }

  getOrderDetails(orderno) {
    this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/orders?orderno=' + orderno,
    {headers: this.authcredheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      }
    ));
  }
  getOrderShippingAddress(id: number) {
    this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/shippingadd/' + id,
    {headers: this.authcredheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      }
    ));
  }
  getOrderBillingAddress(id: number) {
    this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/billingadd/' + id,
    {headers: this.authcredheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      }
    ));
  }

}
